import { render, staticRenderFns } from "./AssignmentsOwlCarousel.vue?vue&type=template&id=69623c06&"
import script from "./AssignmentsOwlCarousel.vue?vue&type=script&lang=js&"
export * from "./AssignmentsOwlCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69623c06')) {
      api.createRecord('69623c06', component.options)
    } else {
      api.reload('69623c06', component.options)
    }
    module.hot.accept("./AssignmentsOwlCarousel.vue?vue&type=template&id=69623c06&", function () {
      api.rerender('69623c06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/AssignmentsOwlCarousel.vue"
export default component.exports